<template>
  <div class="flex items-start mb-1" :class="'flex-row-reverse'">
    <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
         :class="'note-style'">
      <span class="text-sm">
        <strong>{{ message.creator_email }}</strong>
      </span> <br>
      <span class="text-sm" v-html="$sanitizeHtml(message.note)"></span>

      <div class="flex mt-1 justify-between">
        <div class="flex">
          <vs-icon
              class="mr-2"
              v-if="message.private === 1">
            lock
          </vs-icon>
          <vx-tooltip
              v-else
              :text="message.privileges.map(u => u.email).join(', ')">
            <vs-icon class="mr-2">
              lock_open
            </vs-icon>
          </vx-tooltip>
          <vx-tooltip :text="message.user_emails.map(u => u.email).join(', ')">
            <vs-icon
                class="mr-2"
                v-if="message.user_emails.length > 0">
              email
            </vs-icon>
          </vx-tooltip>
        </div>

        <small class="message-creation">
          {{ sessionFormat(message.created_at) }}
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import dateHelper from '@mixins/dateHelper';

export default {
  name: "MessageItem",
  mixins: [dateHelper],
  filters: {
    human_date(date) {
      return moment(date).locale("es").format("D MMM H:m");
    }
  },
  props: {
    message: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.message-creation {
  font-size: 12px !important;
}

.message-creation .md-icon {
  font-size: 16px !important;
}

.md-chip-message {
  margin-left: 50px;
  margin-top: 2px;
  padding: 5px;
}

.md-chip-message .md-icon {
  color: white;
}

.md-avatar {
  margin: -10px;
}

.message-item {
  padding: 5px 0px;
}

.md-avatar {
  width: 32px;
  min-width: 32px;
  height: 32px;
  font-size: 14px;
}

.md-icon-button {
  min-width: 22px;
  width: 22px;
  height: 22px;
}

.md-icon-button .md-icon {
  font-size: 16px !important;
}

.note-style {
  background-color: #f3f3f3;
  color: #2d2d2d;
}
</style>
